import React from 'react';
import { Button } from '@chakra-ui/react';

const PlaceABidButton = ({ onOpenModal }) => {
  return (
    <Button
      variant="black"
      w={{ base: '100%', md: '170px' }}
      py="22px"
      fontWeight="400"
      mb="30px"
      onClick={() => onOpenModal('bid')}
    >
      Place a Bid
    </Button>
  );
};

export default PlaceABidButton;
